import { Text } from './Text';
import { getShortMissionId, getShortVehicleId } from '../../utils/formatters';
import type { VehicleId } from '../../types/gcs/vehicle';
import { en } from '../../locales/en';
import type { MissionId } from '../../types/gcs/mission';

interface VehicleMissionLabelProps {
  vehicleId: VehicleId;
  missionId?: MissionId;
}

function VehicleMissionLabel({ vehicleId, missionId }: VehicleMissionLabelProps) {
  const vehicleLabel = getShortVehicleId(vehicleId);

  const shortMissionId = missionId ? getShortMissionId(missionId) : null;

  if (!shortMissionId) {
    return null;
  }

  return (
    <Text variant='body2-medium'>
      {vehicleLabel && `${en.vehicleMissionLabel.vehiclePrefix} ${vehicleLabel}`}
      {vehicleLabel && shortMissionId && ' - '}
      {shortMissionId && `${en.vehicleMissionLabel.missionPrefix} ${shortMissionId}`}
    </Text>
  );
}

export default VehicleMissionLabel;
